export default __webpack_public_path__ + "assets/images/Payment_03.adc8d0.webp";